import { useCallback } from "react";
import { isEmpty } from "lodash";
import { KdsStorageKeys, useKdsStorage } from "./kds-storage";
import { EmpresaCompletaModel } from "../../../model/api/gestao/master/empresa-completa";
import { EnumEmpresaConfig } from "../../../model/enums/enum-empresa-config";

export const useEmpresaAtual = () => {
    const { getRegistro } = useKdsStorage()

    const getEmpresaAtual = useCallback((): EmpresaCompletaModel | undefined => {
        const ret = getRegistro(KdsStorageKeys.EmpresaAtual, false) as EmpresaCompletaModel;
        if (isEmpty(ret))
            return undefined;

        return ret;
    }, [getRegistro])

    const getConfigByCod = useCallback((cod: EnumEmpresaConfig): string | undefined => {
        const empresaAtual = getEmpresaAtual()

        if (isEmpty(empresaAtual))
            return undefined;
        if (isEmpty(empresaAtual?.configuracoes))
            return undefined;

        const empresaConfig =
            getEmpresaAtual()
                ?.configuracoes
                .find(x => x.cod === cod)
                ?.vConfig

        if (isEmpty(empresaConfig))
            return undefined

        return empresaConfig as string
    }, [getEmpresaAtual])

    return {
        getEmpresaAtual,
        getConfigByCod
    }
}